// extracted by mini-css-extract-plugin
export var wrapper = "Text-module--wrapper--3T2n2";
export var inner = "Text-module--inner--2kSk7";